import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/clips";

export default function CategoryGrid() {
  const list = categories.filter((cat) => cat.id !== "all");

  return (
    <section className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16" id="categories">
      <SectionHeading
        eyebrow="主题分类"
        title="按你想看的方向找片段"
        description="娱乐八卦、电商带货、游戏开黑、体育赛事、财经现场、科技测评与生活分享，每个分类都按话题热度持续补充。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {list.map((cat, index) => (
          <Link
            key={cat.id}
            to={`/clips?cat=${cat.id}`}
            className={`group flex flex-col justify-between rounded-lg border border-background-200 p-5 transition-colors hover:border-primary-300 ${
              index % 5 === 0 ? "bg-accent-100/70 dark:bg-accent-950/40" : "bg-background-100"
            }`}
          >
            <div className="flex items-start justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <span className="font-heading text-2xl font-bold text-foreground-300 group-hover:text-primary-400">
                {String(cat.count).padStart(2, "0")}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
            <p className="mt-2 font-body text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-label text-primary-600">
              查看片段
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}